import { toObject } from "../../core/utils";

class StationPageTransform {
  constructor() {
    "ngInject";
  }

  justify(data) {
    data.loc.coordinates = { value: data.loc.coordinates };
    return toObject(data);
  }
}

export default StationPageTransform;



// WEBPACK FOOTER //
// ./src/pages/station/station.transforms.js